import '@wlb/shared/i18n/registerAdmin';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { renderAppErrorFallback } from './components/feedback/AppErrorFallback';
import { ErrorBoundary } from './ErrorBoundary';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Outer boundary catches throws from the providers themselves, which the
        one inside App cannot see. Without a fallback it would render null. */}
    <ErrorBoundary fallback={renderAppErrorFallback}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
